/* global document, window */

'use strict';

if (!String.prototype.camelCaseToDash) {
  String.prototype.camelCaseToDash = function () {
    return this.replace(/([A-Z])/g, function ($1) {
      return '-' + $1.toLowerCase();
    });
  };
}
